import React from "react";
import CompanyLayout from "./CompanyLayout";

const About = () => {
  return <CompanyLayout />;
};

export default About;
